export const wrapLastWord = ( text, className ) => {
	const words = text.trim().split( ' ' );
	const lastIndex = words.length - 1;

	const wrappedWords = words.map( ( word, index ) => {
		if ( index === lastIndex ) {
			if ( className ) {
				return `<span class="${ className }"><span class="${ className }-word">${ word }</span></span>`;
			}
			return `<span>${ word }</span>`;
		}
		return word;
	} );

	return wrappedWords.join( ' ' );
};
